import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import {
  MENU,
  NIGHTWEB_APP_CONSTANT,
  filterMenusByThreatPairModule,
} from 'src/app/constants';
import { OrganizationSettingsService, DataService} from 'src/app/services';
import { NightwebUtil } from 'src/app/utils';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent implements OnInit, OnDestroy {
  accessibleMenus: any[] = [];
  loggedInUser: any;
  private threatPairSettingsSub!: Subscription;

  @Input() sidenav: any;

  constructor(
    private nightwebUtil: NightwebUtil,
    private organizationSettings: OrganizationSettingsService,
    private dataService: DataService,
    private router: Router,
  ) {
    this.loggedInUser = this.nightwebUtil.decodeToken(
      this.nightwebUtil.getLoggedInUser(),
    );
  }

  ngOnInit(): void {
    this.getAccessibleMenus();
    this.threatPairSettingsSub =
      this.organizationSettings.threatPairModuleEnabled$
        .pipe(distinctUntilChanged())
        .subscribe(() => this.getAccessibleMenus());
  }

  onMenuClick(menu: any): void {
    if (
      menu?.route === '/end-users' &&
      this.router.url.split('?')[0] === '/end-users'
    ) {
      this.dataService.sendData({ action: 'show-end-user-list' });
    }
  }

  ngOnDestroy(): void {
    this.threatPairSettingsSub?.unsubscribe();
  }

  getAccessibleMenus() {
    if (this.nightwebUtil.isEndUser()) {
      this.accessibleMenus = [];
      return;
    }
    
    const menus = filterMenusByThreatPairModule(
      MENU,
      this.organizationSettings.threatPairModuleEnabled,
    );

    this.accessibleMenus = menus.filter((menu: any) => {
      if (menu.resourceName.toLowerCase() === 'notifications') {
        return false;
      }

      if (
        this.loggedInUser?.organization?.role?.code ===
        NIGHTWEB_APP_CONSTANT.roles.DEVICE_ADMIN
      ) {
        return menu.resourceName.toLowerCase() === 'devices';
      }

      if (menu.requiresSuperAdmin) {
        return this.nightwebUtil.isSuperAdmin();
      }

      if (menu.requiresThreatPairModule) {
        return this.organizationSettings.isThreatPairModuleOn();
      }

      return this.nightwebUtil.isAccessible(menu.resourceName);
    });
  }
}
